import { render, staticRenderFns } from "./updatePackage.vue?vue&type=template&id=78d22d48&scoped=true&"
import script from "./updatePackage.vue?vue&type=script&lang=js&"
export * from "./updatePackage.vue?vue&type=script&lang=js&"
import style0 from "./updatePackage.vue?vue&type=style&index=0&id=78d22d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d22d48",
  null
  
)

export default component.exports